import { LogoutOutlined, SettingFilled, UserOutlined } from '@ant-design/icons';
import { Icons } from '@assets';
import { AppDispatch } from '@config/store';
import { authInfoSelect, handleRemoveToken } from '@entities/auth';
import { Avatar, Dropdown, Menu } from 'antd';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import * as S from '../../style/DropdownMenu.styled';
import { MenuInfo } from 'rc-menu/lib/interface';
import { SwitchShops } from '@components/switchShops';

const DropdownMenu = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();
    const { user: userInfo, shops } = useSelector(authInfoSelect);

    const handleMenuClick = (e: MenuInfo) => {
        if (e.key === 'logout') {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            dispatch(handleRemoveToken());
            navigate('/login');
        }
    };

    return (
        <Dropdown
            overlayStyle={{
                width: '280px',
                zIndex: 1001,
                boxShadow: '0px 2px 15.2px 0px grey',
                borderRadius: '6px',
            }}
            dropdownRender={() => (
                <div onClick={e => e.stopPropagation()}>
                    <S.WrapDropdown>
                        <S.WrapUserCard>
                            <S.WrapUserIcon>
                                <img
                                    src={Icons.IconHumanAddFill}
                                    alt="icon human"
                                />
                            </S.WrapUserIcon>
                            <div>
                                <S.WrapTitle>
                                    <S.SubTitleCard>
                                        {userInfo?.title}
                                    </S.SubTitleCard>
                                    <S.TitleCard>{`${userInfo?.firstname} ${userInfo?.lastname}`}</S.TitleCard>
                                    <S.StyledButton>
                                        <span>
                                            <Link
                                                style={{
                                                    textDecoration: 'none',
                                                    color: 'inherit',
                                                }}
                                                to="/settings"
                                            >
                                                Редактировать профиль
                                            </Link>
                                        </span>
                                    </S.StyledButton>
                                    {shops && shops.length > 1 && (
                                        <SwitchShops />
                                    )}
                                </S.WrapTitle>
                            </div>
                        </S.WrapUserCard>
                        <Menu
                            onClick={handleMenuClick}
                            style={{
                                width: '100%',
                                borderInlineEnd: 'none',
                                boxShadow: 'none',
                            }}
                        >
                            <Menu.Item key="help" icon={<UserOutlined />}>
                                <a
                                    href="https://t.me/proga_support"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Помощь менеджера
                                </a>
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="settings" icon={<SettingFilled />}>
                                <Link to="/settings"> Настройки</Link>
                            </Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="logout" icon={<LogoutOutlined />}>
                                Выйти
                            </Menu.Item>
                        </Menu>
                    </S.WrapDropdown>
                </div>
            )}
            onOpenChange={setVisible}
            open={visible}
            trigger={['click']}
        >
            <Avatar style={{ cursor: 'pointer' }} icon={<UserOutlined />} />
        </Dropdown>
    );
};

export default DropdownMenu;
